// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  geoserverBaseUrl: 'https://redocelote.bioap.com.co/geoserver',
  apiBaseUrl: 'https://redocelote.bioap.com.co/api/',
  baseUrl: 'https://redocelote.bioap.com.co/geoserver/bioap/ows?',
  urlGeoserver: 'https://redocelote.bioap.com.co/geoserver',
  backend_python: 'https://redocelote.bioap.com.co/api/v1/',
  // backend_python: 'http://localhost:8000/api/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
